import './StoryboardPromptGen.css';
import { Alert, Select, Spin, Button, Input } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { useState } from "react";

const noScenesOptions = [
  { value: 3, label: "3 Scenes" },
  { value: 4, label: "4 Scenes" },
  { value: 5, label: "5 Scenes" },
  { value: 6, label: "6 Scenes" },
  { value: 7, label: "7 Scenes" },
  { value: 8, label: "8 Scenes" },
];

const StoryboardPromptGen = ({
  descriptionPrompt,
  onDescriptionChange,
  loading,
  error,
  scenesCount,
  onScenesCountChange,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editText, setEditText] = useState("");
  const [isHovering, setIsHovering] = useState(false);

  return (
    <div className="storyboard-generator-container">
      <div className="prompt-input-card-s">
        {error && (
          <Alert
            type="error"
            showIcon
            title="Couldn't generate description"
            description={error}
            style={{ margin: 20 }}
          />
        )}

        {loading ? (
          <div className="loading-container">
            {"Generating description input..."}
            <Spin />
          </div>
        ) : (
          <div>
            <label>Description</label>

            <div
              className="ip-descWrapper"
              onMouseEnter={() => !isEditing && setIsHovering(true)}
              onMouseLeave={() => setIsHovering(false)}
            >
              {isEditing ? (
                <Input.TextArea
                  value={editText}
                  onChange={(e) => setEditText(e.target.value)}
                  autoSize={{ minRows: 4, maxRows: 8 }}
                  autoFocus
                />
              ) : (
                <>
                  <div className="description">{descriptionPrompt}</div>
                  {isHovering && (
                    <button
                      className="ip-pencilBtn"
                      onClick={() => {
                        setEditText(descriptionPrompt);
                        setIsEditing(true);
                        setIsHovering(false);
                      }}
                      title="Edit description"
                    >
                      <EditOutlined />
                    </button>
                  )}
                </>
              )}
            </div>

            {isEditing && (
              <div className="ip-editActions">
                <Button
                  size="small"
                  onClick={() => { setIsEditing(false); setEditText(""); }}
                >
                  Cancel
                </Button>
                <Button
                  type="primary"
                  size="small"
                  disabled={!editText.trim()}
                  onClick={() => {
                    const trimmed = editText.trim();
                    if (!trimmed) return;
                    onDescriptionChange?.(trimmed);
                    setIsEditing(false);
                    setEditText("");
                  }}
                >
                  Save
                </Button>
              </div>
            )}
          </div>
        )}
      </div>

      <div className="image-settings-container">
        <label>Video Settings</label>
        <div className="settings-container">
          <div>
            <div>Number of Scenes</div>
            <div>
              <Select
                className="options"
                value={scenesCount}
                onChange={onScenesCountChange}
                options={noScenesOptions}
                disabled={loading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoryboardPromptGen;